export const MSG = {
  excel: {
    success: 'Успешная загрузка excel.',
    error: 'Ошибка при загрузке excel.',
  },
  comps: {
    success: {
      create: (name) => `Успешное создание компа ${name}`,
      update: (name) => `Успешное обновление компа ${name}`,
      delete: (id) => `Успешное удаление компа ${id}`,
      fetch: 'Успешная загрузка компов.'
    },
    error: {
      fetch: 'Ошибка при загрузке компов.',
      create: 'Ошибка при создании компа.',
      update: 'Ошибка при обновлении компа.',
      delete: 'Ошибка при удалении компа.'
    }
  },
  activewellbores: {
    success: {
      fetch: 'Успешная загрузка активных скважин.',
      create: (name) => `Успешное создание активной скважины ${name}`,
      update: (name) => `Успешное обновление активной скважины ${name}`,
      delete: (id) => `Успешное удаление активной скважины ${id}`
    },
    error: {
      fetch: 'Ошибка при загрузке активных скважин.',
      create: 'Ошибка при создании активной скважины.',
      update: 'Ошибка при обновлении активной скважины.',
      delete: 'Ошибка при удалении активной скважины.',
    },
  },
  customer: {
    success: {
      fetch: 'Успешная загрузка заказчиков.',
      create: (name) => `Успешное создание заказчика ${name}`,
      update: (name) => `Успешное обновление заказчика ${name}`,
      delete: (id) => `Успешное удаление заказчика ${id}`
    },
    error: {
      fetch: 'Ошибка при загрузке заказчика.',
      create: 'Ошибка при создании заказчика.',
      update: 'Ошибка при обновлении заказчика.',
      delete: 'Ошибка при удалении заказчика.',
    }
  },
  generals: {
    success: {
      update: (name) => `Успешное обновление generals ${name}`,
    },
    error: {
      fetch: 'Ошибка при загрузке общей информации по активным скважинам. Нет списка ids активных.',
      update: 'Ошибка при обновлении generals.',
    }
  },
  incidents: {
    success: {
      fetch: 'Успешная загрузка инцидентов.',
      create: (name) => `Успешное создание инцидента ${name}`,
      update: (name) => `Успешное обновление инцидента ${name}`,
      delete: (id) => `Успешное удаление инцидента ${id}`
    },
    error: {
      fetch: 'Ошибка при загрузке инцидентов.',
      create: 'Ошибка при создании инцидента.',
      update: 'Ошибка при обновлении инцидента.',
      delete: 'Ошибка при удалении инцидента.',
    }
  },
  portals: {
    success: {
      fetch: 'Успешная загрузка порталов.',
      create: (name) => `Успешное создание портала ${name}`,
      update: (name) => `Успешное обновление портала ${name}`,
      delete: (id) => `Успешное удаление портала ${id}`
    },
    error: {
      fetch: 'Ошибка при загрузке порталов.',
      create: 'Ошибка при создании портала.',
      update: 'Ошибка при обновлении портала.',
      delete: 'Ошибка при удалении портала.',
    }
  },
  statuswellbores: {
    error: {
      fetch: 'Ошибка при статусов ГТИ',
    }
  },
  user: {
    success: {
      fetch: 'Успешная загрузка пользователей.',
      create: (name) => `Успешное создание пользователя ${name}`,
      update: (name) => `Успешное обновление пользователя ${name}`,
      delete: (id) => `Успешное удаление пользователя ${id}`
    },
    error: {
      fetch: 'Ошибка при загрузке пользователей.',
      create: 'Ошибка при создании пользователя.',
      update: 'Ошибка при обновлении пользователя.',
      delete: 'Ошибка при удалении пользователя.',
    }
  },
  hashtags: {
    success: {
      fetch: 'Успешная загрузка хештегов.',
      create: (name) => `Успешное создание хештега ${name}`,
      update: (name) => `Успешное обновление хештега ${name}`,
      delete: (id) => `Успешное удаление хештега ${id}`
    },
    error: {
      fetch: 'Ошибка при загрузке хештегов.',
      create: 'Ошибка при создании хештега.',
      update: 'Ошибка при обновлении хештега.',
      delete: 'Ошибка при удалении хештега.',
    }
  },
  portalusers: {
    success: {
      fetch: 'Успешная загрузка пользователей порталов.',
      create: (name, portal) => `Успешное создание пользователя ${name} портала ${portal}`,
      update: (name, portal) => `Успешное обновление пользователя ${name} портала ${portal}`,
      delete: (id, portal) => `Успешное удаление пользователя ${id} портала ${portal}`
    },
    error: {
      fetch: 'Ошибка при загрузке пользователей порталов.',
      create: 'Ошибка при создании пользователя портала.',
      update: 'Ошибка при обновлении пользователя портала.',
      delete: 'Ошибка при удалении пользователя портала.',
    }
  },
  documents: {
    success: {
      fetch: 'Успешная загрузка документов.',
      create: (name) => `Успешное создание документа ${name}`,
      update: (name) => `Успешное обновление документа ${name}`,
      delete: (id) => `Успешное удаление документа ${id}`,
      download: 'Успешная загрузка документа.',
      upload: 'Успешная загрузка файла.'
    },
    error: {
      fetch: 'Ошибка при загрузке документов.',
      create: 'Ошибка при создании документа.',
      update: 'Ошибка при обновлении документа.',
      delete: 'Ошибка при удалении документа.',
      download: 'Ошибка при загрузке документа.',
      preview: (title) => `Ошибка при предпросмотре документа ${title}.`,
      upload: 'Ошибка при загрузке файла.',
      invalidFile: 'Недопустимый формат файла.',
      fileTooLarge: 'Файл слишком большой.'
    }
  }
}